import * as React from "react"
import { useForm } from "react-hook-form"
import { InlineWidget } from "react-calendly"

export const ConsultationForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const formSubmission = (event: any) => {
    event.preventDefault()

    const myForm = event.target
    const formData: any = new FormData(myForm)

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        alert("Thank you for your submission")
      })
      .catch((error) => alert(error))
  }

  const onSubmit = (data: any) => {
    formSubmission(data)
  }

  return (
    <div className="bg-completedProject">
      <div className="container mx-auto py-5">
        <div className="mt-10 pt-5">
          <h2 className="text-2xl text-center whitespace-nowrap text-black text-black">
            Book a <span className="font-bold">Free Consultation Today!</span>
          </h2>
        </div>
        <div className="flex justify-center">
          <InlineWidget
            styles={{ width: "90%", minHeight: "800px" }}
            url="https://calendly.com/visualfolio-info/30min"
          />
          {/* <!-- End of Meetings Embed Script --> */}
        </div>
      </div>
    </div>
  )
}
